import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { FullReservation } from '../../../models/reservation/full-reservation';
import { Reservation } from '../../../models/reservation/reservation';

@Injectable({
  providedIn: 'root',
})
export class ReservationApiService {
  // Inject the HttpClient service to make HTTP requests
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/Reserva`;

  /**
   * Gets all full reservations by date and section
   */
  getFullReservations(
    date: string,
    secao: number,
    periodo: string
  ): Observable<FullReservation[]> {
    const params = new HttpParams()
      .set('date', date)
      .set('secao', secao.toString())
      .set('periodo', periodo);

    return this.http.get<FullReservation[]>(
      `${this.apiUrl}/full-reservations`,
      { params }
    );
  }

  /**
   * Search for all reservations by an user or specific date
   */
  getUserReservations(
    user: string,
    date?: Date
  ): Observable<FullReservation[]> {
    let params = new HttpParams().set('user', user);

    if (date) {
      params = params.set('date', date.toISOString().split('T')[0]);
    }

    return this.http.get<FullReservation[]>(
      `${this.apiUrl}/user-reservations`,
      { params }
    );
  }

  /**
   * Create a new reservation
   */
  createReservation(reserva: Reservation): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/new-reservation`,
      reserva,
      { responseType: 'text' as 'json' }
    );
  }

  /**
   * Update a desk from a reservation
   */
  updateReservationTable(reserva: Reservation): Observable<Reservation> {
    return this.http.put<Reservation>(`${this.apiUrl}/update-table`, reserva);
  }

  /**
   * Reservation's check-in 
   */
  checkInReservation(reserva: FullReservation): Observable<FullReservation> {
    return this.http.put<FullReservation>(`${this.apiUrl}/checkin`, reserva);
  }

  /**
   * Delete/Cancel a reservation
   */
  cancelReservation(
    reserva: FullReservation,
    responsible: string
  ): Observable<{ message: string }> {
    const params = new HttpParams().set('responsible', responsible);
    return this.http.delete<{ message: string }>(`${this.apiUrl}/cancel`, {
      body: reserva,
      params,
    });
  }
}
